export default "__VITE_ASSET__DPHphLDK__"